import $ from 'jquery';
import Util from 'root/module/util';

var Button = {
    init: function() {
        this.setEvents();
    },

    setEvents: function() {
        $(document).on('click',   '.button-dropdown > button',               this.toggleDropdown);
        $(document).on('click',   '.button-dropdown[data-update="true"] li', this.selectDropdownOption);
        $(document).on('click',   '.button-group > button',                  this.groupButtonClick);
        $(document).on('keydown', '.number-input input',                     this.numberInputKeydown);
        $(document).on('blur',    '.number-input input',                     this.numberInputBlur);
        $(document).on('click',   '.number-input-minus',                     this.numberInputMinus);
        $(document).on('click',   '.number-input-plus',                      this.numberInputPlus);
        $(document).on('click',   this.hideDropdown);
    },

    hideDropdown: function(e) {
        // inline search box
        if ($(e.target).prop('tagName') === 'INPUT' && $(e.target).parents('.dropdown-search').length) {
            return;
        }

        // when the launch button is clicked
        if ($(e.target).prop('tagName') === 'BUTTON' && $(e.target).parent('.button-dropdown').length) {
            return;
        }

        var dropdown = $(e.target).parents('.button-dropdown');

        if (dropdown.length && dropdown.data('autoclose') === false) {
            return;
        }

        $('.button-dropdown > div').hide();
        $('.button-dropdown-div').hide();
    },

    toggleDropdown: function(e) {
        var container = $(this).parent();
        var do_append  = container.data('append');
        var do_flip    = container.data('flip');
        var do_trim    = container.data('trim') !== false;
        var add_scroll = container.data('addscroll');

        var dropdown_div = container.data('dropdown');

        if (!dropdown_div) {
            dropdown_div = $(this).next('div');
            container.data('dropdown', dropdown_div);
        }

        var dropdown_search = dropdown_div.find('.dropdown-search input');

        $('.button-dropdown > div').not(dropdown_div).hide();
        $('.button-dropdown-div').not(dropdown_div).hide();

        if (dropdown_div.is(':visible')) {
            dropdown_div.hide();

            if (do_flip) {
                dropdown_div.css({
                    'margin-right' : '',
                    'margin-left'  : ''
                });
            }
        } else {
            if (do_flip) {
                var position = container.position();
                var offset = container.offset();

                if (container.hasClass('button-dropdown-left')) {
                    // flip to the left
                    if (offset.left + dropdown_div.width() > $(window).width()) {
                        dropdown_div.css('margin-left', (offset.left + dropdown_div.width() - $(window).width()) * -1);
                    }
                } else {
                    // flip to the right
                    if (position.left < dropdown_div.width()) {
                        dropdown_div.css('margin-right', (dropdown_div.width() - position.left) * -1);
                    }
                }
            }

            dropdown_div.show();

            if (do_append) {
                var full_size = container.hasClass('button-dropdown-full');
                var containing_block = null;
                var parent = container.parent();

                // set size before calculating the top/left positions
                if (full_size) {
                    if (do_trim) {
                        dropdown_div.css({
                            'width': container.width(),
                            'max-width': 'none'
                        });
                    } else {
                        dropdown_div.css({
                            'min-width': container.width(),
                            'max-width': 'none'
                        });
                    }
                }

                var top    = container.hasClass('button-dropdown-up')   ? container.offset().top - dropdown_div.height() : container.offset().top + container.height();
                var left   = container.hasClass('button-dropdown-left') ? container.offset().left : container.offset().left - (dropdown_div.width() - container.width());

                if (container.data('offset')) {
                    left += parseInt(container.data('offset').split(',')[0], 10);
                    top  += parseInt(container.data('offset').split(',')[1], 10);
                }

                if (add_scroll) {
                    top  += $(window).scrollTop();
                    left += $(window).scrollLeft();
                }

                while (parent) {
                    if (parent.css('transform') !== 'none' ||
                        parent.css('transform-style') !== 'flat' ||
                        parent.css('perspective') !== 'none' || parent.css('filter') !== 'none') {
                        containing_block = parent;
                        break;
                    }

                    parent = parent.parent();

                    if (parent.prop('tagName').toLowerCase() === 'body') {
                        break;
                    }
                }

                if (containing_block) {
                    top -= containing_block.offset().top;
                    left -= containing_block.offset().left;
                }

                dropdown_div.css({
                    top    : Math.max(10, top) - $(window).scrollTop(),
                    left   : Math.max(10, left),
                    bottom : 'auto',
                    right  : 'auto'
                });

                // auto flip
                if (top + dropdown_div.height() > $(window).height() + $(window).scrollTop()) {
                    container.addClass('button-dropdown-up');

                    dropdown_div.css({
                        top: Math.max(10, container.offset().top - dropdown_div.height()) - $(window).scrollTop()
                    });
                }
            }

            if (dropdown_search.length && dropdown_search.data('search') !== 'off') {
                dropdown_search.off('keyup.search');
                dropdown_search.on('keyup.search', function() {
                    var search_val = $(this).val().toLowerCase().trim();

                    if (search_val) {
                        var found_total = 0;

                        dropdown_div.find('ul.dropdown > li')
                            .not('.dropdown-title')
                            .not('.separator')
                            .each(function() {
                                var dropdown_val = $(this).text().toLowerCase().trim();

                                if (dropdown_val.indexOf(search_val) === -1) {
                                    $(this).hide();
                                } else {
                                    $(this).show();
                                    found_total++;
                                }
                        });

                        dropdown_div.find('ul.dropdown').toggleClass('dropdown-search-empty', found_total === 0);
                    } else {
                        dropdown_div.find('ul.dropdown > li').show();
                        dropdown_div.find('ul.dropdown').removeClass('dropdown-search-empty');
                    }
                });

                if (!dropdown_div.find('ul.dropdown').attr('data-empty')) {
                    dropdown_div.find('ul.dropdown').attr('data-empty', 'No matches found');
                }

                // reset on show
                if (dropdown_search.val()) {
                    dropdown_search.val('').trigger('keyup.search');
                }
            }
        }
    },

    selectDropdownOption: function(e) {
        var option_selected = $(e.currentTarget);

        if (option_selected.hasClass('disabled')) {
            return;
        }

        option_selected.parents('.button-dropdown:first').children('button').html(option_selected.html());
        option_selected.addClass('selected').siblings().removeClass('selected');
    },

    groupButtonClick: function(e) {
        if ($(this).parent().data('autohighlight') === false) {
            return;
        }

        $(this).parent().children('button').removeClass('active')
        $(this).addClass('active');
    },

    maskNumberInput: function(input) {
        var inputs = [];

        if (typeof input === 'undefined') {
            $('.number-input input').each(function() {
                inputs.push($(this));
            });
        } else {
            inputs = [input];
        }

        inputs.forEach(function(input) {
            var val = parseInt(input.val(), 10);

            var min = parseInt(input.attr('min'), 10);
            var max = parseInt(input.attr('max'), 10);

            // use class disabled instead of prop so that the button can still have :focus state
            input.parents('.number-input').find('.number-input-minus').toggleClass('disabled', val <= min);
            input.parents('.number-input').find('.number-input-plus').toggleClass('disabled', val >= max);
        });

    },

    numberInputKeydown: function(e) {
        var input = $(e.currentTarget);
        var old_val = input.val();

        var min = parseInt(input.attr('min'), 10);
        var max = parseInt(input.attr('max'), 10);

        if (e.which === 38) {
            // up
            e.preventDefault();
            input.parents('.number-input').find('.number-input-plus').click();
            return;
        } else if (e.which === 40) {
            // down
            e.preventDefault();
            input.parents('.number-input').find('.number-input-minus').click();
            return;
        }

        setTimeout(function() {
            var new_val = input.val();

            if (Util.isNumeric(new_val)) {
                if (new_val > max) {
                    input.val(max);

                }

                Button.maskNumberInput(input);
                input.trigger('c:input');
            } else {
                if (new_val === '') {
                } else {
                    input.val(old_val);
                    Button.maskNumberInput(input);
                    Button.trigger('c:input');
                }
            }
        }, 50);
    },

    numberInputBlur: function(e) {
        var input = $(e.currentTarget);

        var min = parseInt(input.attr('min'), 10);
        var max = parseInt(input.attr('max'), 10);

        var new_val = input.val();

        if (new_val > max) {
            input.val(max);
            Button.maskNumberInput(input);
            input.trigger('c:input');
            return;
        }

        if (new_val < min) {
            input.val(min);
            Button.maskNumberInput(input);
            input.trigger('c:input');
            return;
        }
    },

    numberInputMinus: function(e) {
        var input         = $(e.currentTarget).parents('.number-input:first').find('input');
        var min           = input.attr('min');
        var initial_value = min === undefined ? 0 : min;
        var val           = input.val() !== '' ? input.val() : initial_value;
        var current_val   = parseInt(val, 10);
        var new_val       = min ? Math.max(current_val - 1, parseInt(min, 10)) : current_val - 1;

        input.val(new_val);
        Button.maskNumberInput(input);
        input.trigger('c:input');
    },

    numberInputPlus: function(e) {
        var input         = $(e.currentTarget).parents('.number-input:first').find('input');
        var min           = input.attr('min');
        var initial_value = min === undefined ? 0 : min;
        var val           = input.val() !== '' ? input.val() : initial_value;
        var current_val   = parseInt(val, 10);
        var max           = input.attr('max')
        var new_val       = max ? Math.min(current_val + 1, parseInt(max, 10)) : current_val + 1;

        input.val(new_val);
        Button.maskNumberInput(input);
        input.trigger('c:input');
    }
};

export default Button;
